import { combineReducers } from 'redux';

import { UPDATE_SEARCH_SUGGESTIONS } from '../../constants/constants';
import { UPDATE_EVENT_SAVED_BY_YOU } from '../events/actions';

const query = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_SEARCH_SUGGESTIONS && payload.query) {
        nextState = payload.query;
    }

    return nextState;
};

const event = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_SEARCH_SUGGESTIONS && payload.event) {
        nextState = payload.event;
    }

    return nextState;
};

const categories = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_SEARCH_SUGGESTIONS && payload.categories) {
        nextState = payload.categories;
    }

    return nextState;
};

const events = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_SEARCH_SUGGESTIONS && payload.events) {
        nextState = payload.events;
    }

    return nextState;
};

const rawEvents = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_SEARCH_SUGGESTIONS && payload.rawEvents) {
        nextState = payload.rawEvents;
    }

    if (type === UPDATE_EVENT_SAVED_BY_YOU) {
        const { eventId, savedByYou } = payload;

        nextState = {
            ...nextState,
            [eventId]: {
                ...nextState[eventId],
                saves: {
                    savedByYou,
                },
            },
        };
    }

    return nextState;
};

const history = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_SEARCH_SUGGESTIONS && payload.history) {
        nextState = payload.history;
    }

    return nextState;
};

export default combineReducers({
    query,
    event,
    categories,
    events,
    rawEvents,
    history,
});
